import { trace } from 'rytm-helpers'
import Pizzicato from 'pizzicato'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'

const FREQ_CUT_LOW = .03;
const FREQ_CUT_HIGH = .8;

class Sound {
  /**
  * Sound class constructor  
  * @constructor
  * @param {String} file - file name with extension  
  * @param {String} path - file path  
  **/
  constructor(filename, path) {
    this.id = filename.split('.').slice(0, -1).join('.')
    this.filename = filename
    this.path = path
    this.pitch = 1
    this.pz = null
    this.analyser = Pizzicato.context.createAnalyser()
  }
  /**
   * Play sound
   */
  play(params) {
    this.pitch = params.pitch ? params.pitch : 1
    this.pan = params.pan ? params.pan : 0
    // trace("play sound", this.id)
    if (this.pz) {
      this.pz.play()
      this.onPlaybackStarted()
    } else {
      // create pizzicato sound
      const pizzParams = {
        source: 'file',
        options: {
          path: this.path,
          loop: params.loop ? params.loop : false
        }
      }
      this.pz = new Pizzicato.Sound(pizzParams, () => {
        this.pz.play()
        this.onPlaybackStarted()
      })
      // connect the analyser
      this.pz.connect(this.analyser)
      // setup attack
      this.pz.attack = .01
      this.pz.release = 1
      // setup pan
      if (this.pan != 0) {
        const stereoPan = new Pizzicato.Effects.StereoPanner({pan: this.pan})
        this.pz.addEffect(stereoPan)
      }
      // // DELAY FX
      // const delay = new Pizzicato.Effects.Delay({
      //   feedback: .4,
      //   time: .2,
      //   mix: .1
      // })
      // this.pz.addEffect(delay)
      // // REVERB FX
      // const reverb = new Pizzicato.Effects.Reverb({
      //   time: 1,
      //   decay: .3,
      //   // reverse: true,
      //   mix: 0.2
      // });
      // this.pz.addEffect(reverb);
    }
  }
  onPlaybackStarted() {
    // this.pz.sourceNode.playbackRate.value = this.pitch
    if (this.pitch != 1) {
      TweenMax.set(this.pz.sourceNode.playbackRate, {value: 1})
      TweenMax.to(this.pz.sourceNode.playbackRate, .4, {value: this.pitch})
    }
  }
  /**
   * Stop sound
   */
  stop() {
    if (this.pz) {
      this.pz.stop()
    }
  }
  /**
   * Destroy sound
   */
  destroy() {
    if (this.pz) {
      this.pz.stop()
      this.pz = null
    }
  }
  /**
   * Get sound Frequency data
   * Credits: https://stackoverflow.com/questions/47626854/pizzicato-js-no-frequency-data
   */
  getFrequencyData() {
    let frequencyData = null
    if (this.analyser) {
      try {
        const bufferLength = this.analyser.frequencyBinCount
        
        const tmpData = new Uint8Array(bufferLength)
        this.analyser.getByteFrequencyData(tmpData)
        // cut lowest and highesr frequencies
        frequencyData = []
        const total = tmpData.length
        for (let i = 0; i < total; i++) {
          if (i > total * FREQ_CUT_LOW 
            && i < total - total * FREQ_CUT_HIGH) {
              frequencyData.push(tmpData[i])
          }
        }
        
      } catch (error) {
        console.warn(error)
      }
    }
    return frequencyData
  }

}

export default Sound;
